import React from "react";

import { BackLink as BaseBackLink, type BackLinkBaseProps } from "@packages/ds";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import { selectLastRoute } from "Reducers/app/selectors";
import { RootState } from "Store/configureStore";

export type BackLinkProps = Omit<
  BackLinkBaseProps,
  "backText" | "destinationText"
> & {
  from: string;
  to: string;
};

const BackLink = ({ from, to, children, ...props }: BackLinkProps) => {
  const location = useLocation();
  const route = useSelector<RootState>(state => to || selectLastRoute(state));
  const fromPage = from || location.state?.from;

  return (
    <BaseBackLink
      to={(location.state?.url || to || route) as string}
      {...props}
    >
      {children ||
        (fromPage && (
          <>
            <FormattedMessage id="back" />{" "}
            {fromPage !== " " && <FormattedMessage id={`back.${fromPage}`} />}
          </>
        ))}
    </BaseBackLink>
  );
};

export default BackLink;
